module.exports = __webpack_public_path__ + "img/UTSAND-4.46986f8e.jpg";